import React, { FC } from "react";
import tick from "../../assets/images/tick.svg";
import { DataTable } from "./DataTable";
import { useHistory } from "react-router-dom";
import { Image } from "cloudinary-react";
export const Header: FC<{}> = () => {
  const { push } = useHistory();
  return (
    <section>
      <div className="header">
        <div className="top">
          <div className="coming-soon">
            <span>Latest</span>
            <p>Contact admins to buy crypto </p>
          </div>
        </div>
        <div className="container">
          <div className="hero">
            <div className="row">
              <div className="col-12 col-lg-6">
                <div className="tagline">
                  <h1>
                    Bringing Digital <span>Currencies</span> to you.
                  </h1>
                  <p>
                    Buy and sell digital currencies in Ghana. It takes a few
                    seconds to create an account.
                  </p>
                  <button onClick={() => push("/register")}>Get Started</button>
                  <div className="help">
                    <img
                      style={{
                        width: "17px",
                        height: "17px",
                        marginRight: "7px",
                        marginTop: "30px",
                      }}
                      src={tick}
                      alt=""
                    />
                    <p>Let's help you get started with bitcoin</p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <Image publicId="SpeednanceMockup_yodjj8.svg" />
              </div>
            </div>
            <div className="rate">
              <div className="heading">
                <h2>
                  Market <span>Prices.</span>
                </h2>
              </div>
              <DataTable />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
